import axios from 'axios'
import { useQuery } from '@tanstack/react-query'

interface Banco {
  ispb: string
  name: string
  code: string
}

export function useBankData() {
  return useQuery({
    queryKey: ['bancos-brasil'],
    queryFn: async () => {
      try {
        const response = await axios.get('https://brasilapi.com.br/api/banks/v1')
        const bancosFiltrados = response.data.filter((banco: { code: any }) => banco.code)
        const bancosOrdenados = bancosFiltrados.sort(
          (a: { code: any }, b: { code: any }) => Number(a.code) - Number(b.code)
        )

        return bancosOrdenados as Banco[]
      } catch (error) {
        console.error('Erro ao buscar bancos:', error)
      }
    }
  })
}
